import { CASHFLOW_FROM_BANKING } from '../Financials/constants';

export const CFB_UNIT_STORAGE_KEY = 'aica.cfb.unit';

export const BANK_STATEMENTS = 'bankStatements';

// Must match the server's max window in InsightsFinanceService.
export const BANK_RANGE_MAX_MONTHS = 120;

// Quick-range options on the Banking "Time Period" control.
export const QUICK_RANGE_KEYS = {
    LAST_FY: 'LAST_FY',
    LAST_12M: 'LAST_12M',
    CURRENT_FY: 'CURRENT_FY',
} as const;

// Quick-range options for the CFB/drill-down Time Period control, in design order.
export const CFB_QUICK_RANGES = [
    { id: QUICK_RANGE_KEYS.LAST_12M, label: 'Last 12 M' },
    { id: QUICK_RANGE_KEYS.LAST_FY, label: 'Last FY' },
    { id: QUICK_RANGE_KEYS.CURRENT_FY, label: 'Current FY' },
] as const;

/** Toolbar width below which the CFB quick ranges fold into the overflow menu. */
export const CFB_INLINE_RANGES_MIN_WIDTH = 1000;

/** Header row width below which Excel Analysis folds into a ⋮ menu (with/without the account dropdown). */
export const BANK_STATEMENTS_HEADER_MIN_WIDTH = 900;
export const BANK_STATEMENTS_HEADER_MIN_WIDTH_WITH_ACCOUNT = 1200;

export const BANKING_TYPES = [
    { id: BANK_STATEMENTS, label: 'Bank Statements' },
    { id: CASHFLOW_FROM_BANKING, label: 'Cashflow From Banking' },
];
